var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAssCaptain = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 82 81",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-11521,-529)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,10440,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ass-Captain",
    transform: "matrix(1,-0,-0,1,1081.05,529)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image1",
    x: 4.983,
    y: 5.163,
    width: "72px",
    height: "70px"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    id: "_Image1",
    width: "72px",
    height: "70px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABGCAYAAABv59I3AAAACXBIWXMAAA7EAAAOxAGVKw4bAAAFGElEQVR4nO2cW4hVVRyHvzWOlzK10sBSUfLWxe5hVorQRSuiwDKTqOiCkQ89VA8lEkIPPRglREQUERgV9hIU+FAERYHYDYSy7MHGW5pmqZmpM/P1sPbQODNn5sy+ntH5YLPhnLP+67d+Z5211/6vtQ80EGpQh1StozNNVQvoQJ0DfAVsVh+rWk9DoV6g/uX/tKvLqtbVMKir7c6P6uiqtVWOOkP9uweDjquLqtZXKWqT+lYP5nTQoo6sWmdlqGere3oxyFN6wFZf7sMc1Q1V66wEdWYd5nRwW9V6S8eer1y12KaeWbXm0lBHqbv7YVCburhq3aWhvt4Pczo4NcYidZp6MIVBqveWrbeKe7HFwKiUZVd4Ms+L1PHq3pS9R/Vf9aaq21EIxlTGmgzmdPCdOqzq9uSOOtZ4uc6DpWXpLnMMehiYlFOsR3OK0yehjErUc4HtQF7ZwnbgihDCppzi1aSsHrSM/MyBqHudenqOMWtWVCjJgPpAAaFnADcUEPcEyuhBzwDnFxA3AMsLiNutkkwYVyHGAucA45Lz+cDM5JgNDM1aT63qgU3AluT4GdgD7AP2An+EEP7JUkG/DUoG3NnAnOR8GTAcaCaOM81p4uZIG9Da6fgV2AhsSM6bQwht9QY7oSHJeDEBmAJMTo5JwMTk9YnAmK7lBhhHgZ3Ajk7nls5HCOFgx4eDGoB5wGrgcuDkm6X2D4GtwCvAq0GdB6wHTt6bwHS0Ak81AbczaE5PNAOPNBEHsUF6ZnNIZqNvA3czsAffvPkFWBAAjEmoj4H5DJoE8co2N4TQ0gQQQjhMHIvWViqrMdgGLAghtED3edBIokl3kO/N5UBhE7AwhLC744VuP6dksvgmcH+JwhqBHcB1IYTtnV/sdrMaQjhGTE+8RpwLnApsBK7pag70MiCrzcSr21IaaCdaAfxA7DkHe3qzZsNDCK3AQ8CLBQlrBL4BbqllDtRxSU960hpiHnh4ftoq53Pg1hDCkd4+1OdPJ+lJTwAv5SSsEdgILOrLHKhzbAkhtAMrgVXEdMFAZj1wYwhhf+6RjYt/zxt3Www02tVPLHofttGkJ6ttayo+VM8q1JwuRj2tHq640fWyzpgYLBf18apbXgfvqWeUbk4nk5arxyo2oRYfGacpqcljhvwFjZsi2ZlMU1KTh0GXEtOTjchkNVMb8zBoTg4ximI8Gb+8PAy6NocYRXEeGfNamcYOdQRwgMZdS2sDJoUQfksbIGsPmk7jmgOx98zNEiCrQRdmLF8GmbbIDBrUB1kNmpqxfBlMU8ekLZzVoLw2ZRZJE3GXSurCWRgIBkEVBiX3OBPSli+ZKWkLZulBVwIjMpQvk+lpC2YxaEGGsrU4BOwqIO6MtAWzGHRzhrJd2U9c8r6auAH0OeLuCnOKn9qgVKhDzScH1K5+YHwKqKlLHaPVZ9UjOdTTZpmPUalTksZlEfy+Ot8+kujqVPUF9feMJpX3GJV6fUqDjqrfqrNS1DlOfVc9lNKgVQVYUVPskhQCN6gLzfB8hTpEvUR9I0X9n+bpQV9CV9Qp6rj6vfpgARquMuac611Z2aqelreOWuLW1iFon3qPBT6RY7xYXKx+XYeePWo5E1v1y16E/GRcWCxtkc74Jyl3qZ+prTV0HVDLyT6o7/Qg4E/jsnSls2v1TnWX3ZfHd6sTyxJxkbql0zezUi3ikadUqGPU+4x/0qTx577EsldXjX+OVN2qZR+ow9RZatrn9PkPYJyjLhwSlKsAAAAASUVORK5CYII="
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAssCaptain);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Ass_Captain.f46273f946e54caad0fa930c50fe1957.svg";